module.exports = __webpack_public_path__ + "img/code_asi_6.bf9f7d54.png";